export default () => ({
  course: {
    context     : {},
    permissions : [],
    topics      : []
  },
  content: {
    context     : {},
    permissions : []
  },
  selectedContent       : {},
  selectedIndexToRender : 0,
  backupValue           : {},
  eula                  : []
});
